import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@agent/context/AuthContext";
import Login from "@agent/pages/Login";
import Composer from "@agent/pages/Composer";
import Library from "@agent/pages/Library";
import Settings from "@agent/pages/Settings";
import { Layout } from "@agent/components/Layout";

const TOAST_OPTIONS = {
  style: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    color: "#0f172a",
    borderRadius: "12px",
    fontFamily: "'Inter', sans-serif",
    fontSize: "13px",
    boxShadow: "0 4px 20px rgba(15,23,42,0.08)",
  },
};

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen bg-[#f6f8fb] flex items-center justify-center">
        <span className="font-display text-indigo-600 text-sm font-medium">Authenticating…</span>
      </div>
    );
  if (user === false) return <Navigate to="/agent/login" replace />;
  return <Layout>{children}</Layout>;
}

// AgentApp is mounted from the main App.js as <Route path="/agent/*" element={<AgentApp />} />
export default function AgentApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="" element={<Protected><Composer /></Protected>} />
        <Route path="composer/:id" element={<Protected><Composer /></Protected>} />
        <Route path="library" element={<Protected><Library /></Protected>} />
        <Route path="settings" element={<Protected><Settings /></Protected>} />
      </Routes>
      <Toaster theme="light" position="bottom-right" toastOptions={TOAST_OPTIONS} />
    </AuthProvider>
  );
}
